"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SmallLoader = function SmallLoader(_ref) {
  var color = _ref.color,
      otherProps = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/_react.default.createElement(LoaderWrapper, otherProps, /*#__PURE__*/_react.default.createElement(Ball, {
    color: color
  }), /*#__PURE__*/_react.default.createElement(Ball, {
    color: color
  }), /*#__PURE__*/_react.default.createElement(Ball, {
    color: color
  }));
};

var LoaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoaderWrapper"
})(["display:flex;justify-content:center;"]);

var Ball = _styledComponents.default.div.withConfig({
  displayName: "Ball"
})(["width:0.5rem;height:0.5rem;margin:1rem 0.15rem;background:", ";border-radius:9999px;animation:0.6s bounce infinite alternate;&:nth-child(2){animation-delay:0.2s;}&:nth-child(3){animation-delay:0.4s;}@keyframes bounce{to{opacity:0.3;transform:translate3d(0,-0.5rem,0);}}"], function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return color ? color : theme.brand.light;
});

SmallLoader.propTypes = {
  /** Color of the balls */
  color: _propTypes.string,

  /** Other props */
  otherProps: _propTypes.object
};
var _default = SmallLoader;
exports.default = _default;